import { AccountFull } from '../models/account';
import { Role, ROLE_TYPE, RoleDescription } from '../models/role';
import { UserFull } from '../models/user';
import { HttpConnectorAdapter } from './../adapters/http-connector-adapter';

export default class SchedulingProvider {
    private endpointAdmin: string;

    constructor() {
        this.endpointAdmin = `${process.env.REACT_APP_ADMIN_TOOL_API}scheduling`;
    }

    init = () => {
        return HttpConnectorAdapter;
    };

    fetchSchedulingAccounts = () => {
        return this.init()
            .getWithCredentials(`${this.endpointAdmin}/available_accounts`)
            .then(response => {
                const status = response.status;
                const { docs, total } = response.data;

                return {
                    status,
                    accounts: docs as AccountFull[],
                    total_account: total
                };
            });
    };

    fetchUserByEmailAndAccountId = (userEmail: string, accountId: string, roleType: ROLE_TYPE = "scheduling") => {
        return this.init()
            .getWithCredentials(
                `${this.endpointAdmin}/user/${userEmail}/account/${accountId}?role_type=${roleType}`
            )
            .then(response => {
                const { user_data, user_roles } = response.data;
                return {
                    user: user_data as UserFull,
                    roles: user_roles as Role[]
                };
            });
    };

    createSchedulingRole = (roleData: RoleDescription, roleType: ROLE_TYPE = "scheduling") => {
        const newRole = { ...roleData } as any;
        delete newRole['id'];
        const headers = { 'Content-Type': 'application/json' };
        return this.init()
            .postWithCredentials(
                `${this.endpointAdmin}/?role_type=${roleType}`,
                JSON.stringify(newRole),
                headers
            )
            .then(response => {
                const role = response.data as RoleDescription;
                const statusCode = response.status;

                return { status: statusCode, role };
            });
    };

    updateShedulingRole = (roleData: RoleDescription, roleType: ROLE_TYPE = "scheduling") => {
        const newRole = { ...roleData } as any;
        const headers = { 'Content-Type': 'application/json' };
        return this.init()
            .putWithCredentials(
                `${this.endpointAdmin}/${roleData.id}?role_type=${roleType}`,
                JSON.stringify(newRole),
                headers
            )
            .then(response => {
                const role = response.data as RoleDescription;
                const statusCode = response.status;

                return { status: statusCode, role };
            });
    };
}
